const lodash = require('lodash')
const { createReducer } = require('../../helpers')
const {
  GET_PROFILE,
  GET_PROFILE_SUCCESS,
  GET_PROFILE_ERROR,
  GET_PROFILE_RESET,

  UPDATE_PROFILE,
  UPDATE_PROFILE_SUCCESS,
  UPDATE_PROFILE_ERROR,
  UPDATE_PROFILE_RESET,

} = require('./constants')

const initialState = {
  profile: {
    data: {},
    loading: false,
    error: false,
  },
  update: {
    data: {},
    loading: false,
    error: false,
  },
}

module.exports = createReducer({
///----------------------GET ADDRESS---------------------------///  
  [GET_PROFILE]: draft => ({
    profile: {
      ...draft.profile,
      loading: true,
    },
  }),
  [GET_PROFILE_SUCCESS]: (draft, action) => ({
    profile: {
      ...draft.profile,
      loading: false,
      data: action.payload.profile,
    },
  }),
  [GET_PROFILE_ERROR]: (draft, action) => ({
    profile: {
      ...draft.profile,
      loading: false,
      error: action.payload.error,
    },
  }),
  [GET_PROFILE_RESET]: () => ({
    profile: {...initialState.profile},
  }),

///-----------------------UPDATE ADDRESS-----------------------///
[UPDATE_PROFILE]: draft => ({
  update: {
    ...draft.update,
    loading: true,
  },
}),
[UPDATE_PROFILE_SUCCESS]: (draft, action) => ({
  update: {
    ...draft.update,
    loading: false,
    data: action.payload.profile,
  },
}),
[UPDATE_PROFILE_ERROR]: (draft, action) => ({
  update: {
    ...draft.update,
    loading: false,
    error: action.payload.error,
  },
}),
[UPDATE_PROFILE_RESET]: () => ({
  update: {...initialState.update},
}),  

}, initialState)
